import {
  Box,
  Card,
  FormControl,
  CardContent,
  Grid,
  TextField,
  Autocomplete,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useFormikContext } from "formik";
import FeatherIcon from "feather-icons-react";
import React from "react";
import CustomTextField from "../../../../components/forms/custom-elements/CustomTextField";
import CustomFormLabel from "../../../../components/forms/custom-elements/CustomFormLabel";
import { Visibility } from "@mui/icons-material";

export const AddQuestion = (props) => {
  let captureForm = useFormikContext();
  const { values, view, questionCategories, handleOpenModal } = props;
const selectedCategory = questionCategories.find(
  (x) => x.id === captureForm.values.questionCategoriesId
)?.name;
  return (
    // <Card>
    <Box>
      <FormControl
        sx={{
          width: "100%",
        }}
      >
        <Box sx={{ ml: 0, mt: 0 }}>
          <CardContent
            sx={{
              padding: "10px 30px 10px 30px",
            }}
          >
            <Grid container spacing={2}>
              <Grid item lg={4} md={12} sm={12}>
                <CustomFormLabel>Select Question Category</CustomFormLabel>
                <Autocomplete
                  id="questionCategoriesId"
                  options={questionCategories}
                  getOptionLabel={(option) => option.name}
                  fullWidth
                  size="small"
                  disabled={view}
                  value={
                    questionCategories.find(
                      (option) =>
                        option.id === captureForm.values.questionCategoriesId
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    captureForm.setFieldValue(
                      "questionCategoriesId",
                      newValue ? newValue.id : ""
                    );
                      if (newValue?.name === "Basic English Questions") {
    captureForm.setFieldValue("option1", "True");
    captureForm.setFieldValue("option2", "False");
    captureForm.setFieldValue("option3", "");
    captureForm.setFieldValue("option4", "");
    captureForm.setFieldValue("answer", "");
  } else {
    captureForm.setFieldValue("option1", "");
    captureForm.setFieldValue("option2", "");
    captureForm.setFieldValue("option3", "");
    captureForm.setFieldValue("option4", "");
    captureForm.setFieldValue("answer", "");
  }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      error={Boolean(
                        captureForm.touched.questionCategoriesId &&
                          captureForm.errors.questionCategoriesId
                      )}
                      helperText={
                        captureForm.touched.questionCategoriesId &&
                        captureForm.errors.questionCategoriesId
                      }
                    />
                  )}
                />
              </Grid>
              <Grid item lg={4} md={12} sm={12}>
                <CustomFormLabel>Question</CustomFormLabel>
                <CustomTextField
                  type="text"
                  id="question"
                  name="question"
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled={view}
                  {...captureForm.getFieldProps("question")}
                  error={Boolean(
                    captureForm.touched?.question &&
                      captureForm.errors?.question
                  )}
                  helperText={
                    captureForm.touched?.question &&
                    captureForm.errors?.question
                  }
                />
              </Grid>
             {selectedCategory !== "Basic English Questions" && (
  <>
    <Grid item lg={4} md={12} sm={12}>
      <CustomFormLabel>Option1</CustomFormLabel>
      <CustomTextField
        {...captureForm.getFieldProps("option1")}
        fullWidth
        size="small"
      />
    </Grid>

    <Grid item lg={4} md={12} sm={12}>
      <CustomFormLabel>Option2</CustomFormLabel>
      <CustomTextField
        {...captureForm.getFieldProps("option2")}
        fullWidth
        size="small"
      />
    </Grid>

    <Grid item lg={4} md={12} sm={12}>
      <CustomFormLabel>Option3</CustomFormLabel>
      <CustomTextField
        {...captureForm.getFieldProps("option3")}
        fullWidth
        size="small"
      />
    </Grid>

    <Grid item lg={4} md={12} sm={12}>
      <CustomFormLabel>Option4</CustomFormLabel>
      <CustomTextField
        {...captureForm.getFieldProps("option4")}
        fullWidth
        size="small"
      />
    </Grid>
  </>
)}
             <Grid item lg={4} md={12} sm={12}>
  <CustomFormLabel>Answer</CustomFormLabel>

  {selectedCategory === "Basic English Questions" ? (
    <Autocomplete
      options={["True", "False"]}
      value={captureForm.values.answer || null}
      disabled={view}
      onChange={(e, value) =>
        captureForm.setFieldValue("answer", value)
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          error={Boolean(
            captureForm.touched.answer &&
              captureForm.errors.answer
          )}
          helperText={
            captureForm.touched.answer &&
            captureForm.errors.answer
          }
        />
      )}
    />
  ) : (
    <CustomTextField
      {...captureForm.getFieldProps("answer")}
      fullWidth
      size="small"
      disabled={view}
      error={Boolean(
        captureForm.touched.answer &&
          captureForm.errors.answer
      )}
      helperText={
        captureForm.touched.answer &&
        captureForm.errors.answer
      }
    />
  )}
</Grid>
              <Grid item lg={4} md={12} sm={12}>
                {!view ? (
                  <>
                    <CustomFormLabel htmlFor="">Attachment </CustomFormLabel>
                    <CustomTextField
                      id="attachment"
                      name="attachment"
                      variant="outlined"
                      fullWidth
                      size="small"
                      type="file"
                      inputProps={{ accept: "image/*" }}
                      onChange={(event) => {
                        const file = event.currentTarget.files[0];
                        captureForm.setFieldValue("attachment", file);
                      }}
                      error={Boolean(
                        captureForm.touched.attachment && captureForm.errors.attachment
                      )}
                      helperText={
                        captureForm.touched.attachment && captureForm.errors.attachment
                      }
                      onBlur={() => captureForm.setFieldTouched("attachment", true)}
                    />
                    {values?.attachment?.name ? (
                      <span>{values?.attachment?.name}</span>
                    ) : (
                      <span>{values?.attachment?.split("_")[1]}</span>
                    )}
                  </>
                ) : (
                  <FormControl fullWidth size="small" variant="outlined">
                    <CustomFormLabel htmlFor="">attachment</CustomFormLabel>
                    <OutlinedInput
                      id="outlined-adornment-password"
                      value={values?.attachment?.split("_")[1]}
                      disabled
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => handleOpenModal(values?.attachment)}
                            edge="end"
                          >
                            <Tooltip title="View Image" placement="bottom">
                              <Visibility />
                            </Tooltip>
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </CardContent>
        </Box>
      </FormControl>
    </Box>
    // </Card>
  );
};
